import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'product-subs',
  templateUrl: './product-subs.component.html',
  styleUrls: ['./product-subs.component.scss']
})
export class ProductSubsComponent implements OnInit {
  @Input()
  itemPrice: string;

  @Input()
  subbedPrice: string;

  priceDifference: string;
  sign: string;

  constructor() {}

  ngOnInit() {
    this.priceDifference = (parseFloat(this.subbedPrice) - parseFloat(this.itemPrice)).toFixed(2);
    this.sign = parseFloat(this.priceDifference) >= 0 ? '-' : '+';
    this.priceDifference = Math.abs(parseFloat(this.priceDifference)).toFixed(2);
  }
}
